<template>
  <div id="mytask-layout" class="theme-indigo">
    <!--Menu Sidebar-->
    <div id="main-menu">
      <div class="sidebar px-4 py-4 py-md-5 me-0">
        <span @click="toggleSidebar"><i class="icofont-close position-absolute end-0 fs-5 text-white pe-3"></i></span>
        <div class="d-flex flex-column h-100">
          <RouterLink to="/dashboard">
            <a href="#" class="mb-0 brand-icon dashboard-link">
              <!-- <span class="logo-icon">
                <img src="../assets/images/Citrine_logo_C.png" alt="Citrine Logo" width="30px">
              </span>
              <span class="logo-text">MIS</span> -->
            </a>
          </RouterLink>
          <!-- Menu: main ul -->
          <ul class="menu-list flex-grow-1 mt-3">
            <li>
              <RouterLink to="/" ><a class="m-link"> <span :class="{ active: isActive('/') }">ΑΡΧΙΚΗ</span></a>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/venues" @click="toggleSidebar"><a class="m-link"> <span :class="{ active: isActive('/venues') }">ΧΩΡΟΙ ΕΚΔΗΛΩΣΕΩΝ</span></a>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/events" @click="toggleSidebar"><a class="m-link"> <span :class="{ active: isActive('/events') }">ΕΚΔΗΛΩΣΕΙΣ</span></a>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/event-categories" @click="toggleSidebar"><a class="m-link"> <span :class="{ active: isActive('/event-categories') }">ΚΑΤΗΓΟΡΙΕΣ</span></a>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/statistics" @click="toggleSidebar"><a class="m-link"> <span :class="{ active: isActive('/statistics') }">ΣΤΑΤΙΣΤΙΚΑ</span></a>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/users" @click="toggleSidebar"><a class="m-link"> <span :class="{ active: isActive('/users') }">ΧΡΗΣΤΕΣ</span></a>
              </RouterLink>
            </li>
            <li>
              <RouterLink to="/notifications-municipality" @click="toggleSidebar"><a class="m-link"><span :class="{ active: isActive('/notifications-municipality') }">ΕΙΔΟΠΟΙΗΣΕΙΣ</span></a>
              </RouterLink>
            </li>
          </ul>


          <!-- Menu: menu collapse btn -->
          <button type="button" class="btn btn-link sidebar-mini-btn text-light" @click="toggleSidebar">
            <span class="ms-2"><i class="icofont-bubble-right"></i></span>
          </button>

        </div>
      </div>
    </div>
    <!-- End of Menu Sidebar -->

    <!-- main body area -->
    <div class="main px-lg-4 px-md-4">
      <!--Navigation bar-->
      <div id="main-header">
        <nav class="navbar py-xl-4 py-3">
          <div class="container-xxl">
            <!-- header rightbar icon -->
            <div class="h-right d-flex align-items-center mr-5 mr-lg-0 order-2">
              <div class="d-flex"></div>
              
              <div class="dropdown notifications zindex-popover">
                <a @click.prevent="toggleNotificationMenu()"
                  class="nav-link dropdown-toggle notifications-menu-toggler pulse" href="#" role="button"
                  data-bs-toggle="dropdown">
                  <i class="icofont-alarm fs-3" id="notificationsRingerIcon" style="color: #888"></i>
                  <span id="notificationBadge" class="position-absolute top-30 start-30 translate-middle badge rounded-pill bg-danger" v-if="notificationCount > 0">  {{ notificationCount }}
                  </span>                </a>
                <div id="NotificationsDiv"
                  :class="{ 'dropdown-menu notifications-menu rounded-lg shadow border-0 dropdown-animation dropdown-menu-sm-end p-0 m-0': !isNotificationsOpen, 'dropdown-menu notifications-menu rounded-lg shadow border-0 dropdown-animation dropdown-menu-sm-end p-0 m-0 show': isNotificationsOpen }"
                  :style="notificationStyle">
                  <div class="card border-0 w380">
                    <div class="card-header border-0 p-3">
                      <h5 class="mb-0 font-weight-light d-flex justify-content-between">
                        <span>Ειδοποιήσεις</span>
                        <span class="badge text-white" id="notificationsCount"></span>
                      </h5>
                    </div>
                    <div class="tab-content card-body">
                      <div class="tab-pane fade show active">
                        <ul class="list-unstyled list mb-0" id="notifications-list"></ul>
                      </div>
                    </div>
                    <a class="card-footer text-center border-top-0">
                      <RouterLink to="/notifications-municipality">Εμφάνιση όλων</RouterLink>
                    </a>
                  </div>
                </div>
              </div>
              <div class="dropdown user-profile ml-2 ml-sm-3 d-flex align-items-center">
                <a @click.prevent="toggleMenu()" class="nav-link dropdown-toggle user-menu-toggler pulse p-0" href="#"
                  role="button" data-bs-toggle="dropdown" data-bs-display="static">
                  <img class="avatar lg" src="../assets/images/newuser.png"
                    alt="profile">
                </a>
                <div
                  :class="{ 'dropdown-menu user-menu rounded-lg shadow border-0 dropdown-animation dropdown-menu-end p-0 m-0': !isMenuOpen, 'dropdown-menu user-menu rounded-lg shadow border-0 dropdown-animation dropdown-menu-end p-0 m-0 show': isMenuOpen }"
                  :style="menuStyle">
                  <div class="card border-0 w280">
                    <div class="card-body pb-0">
                      <div class="d-flex py-1">
                        <img class="avatar" src="../assets/images/newuser.png" alt="profile">
                        <div class="flex-fill ms-3">
                          <p class="mb-0"><span class="text-dark fw-bold user-name" v-if="userInfo">{{ userInfo.name }}</span></p>
                          <small class="user-email" v-if="userInfo">{{ userInfo.email }}</small>
                        </div>
                      </div>
                      <div>
                        <hr class="dropdown-divider border-dark">
                      </div>
                    </div>
                    <div class="list-group m-2">
                      <RouterLink to="/change-password">
                        <a class="list-group-item list-group-item-action border-0"><i class="icofont-lock fs-5 me-3"></i>Αλλαγή κωδικού</a>
                      </RouterLink>
                      <a @click.prevent="logout" href="#" class="list-group-item list-group-item-action border-0 btn-logout"><i class="icofont-logout fs-6 me-3"></i>
                        Αποσύνδεση
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- menu toggler -->
            <button class="navbar-toggler p-0 border-0 menu-toggle order-1" type="button" @click="toggleSidebar">
              <span class="fa fa-bars menuIcon"></span>
            </button>


            <!-- main menu Search-->
         
            <div class="d-flex gap-3 order-0 order-mob-3 col-12 col-sm-6 mb-0 mb-xl-3 gap-3 flex-column-mob align-items-center-mobile justify-content-center-mob">
              <h3 class="page-header fw-bolder mb-0" >{{ pageHeader }} </h3>


              <div class="input-group flex-nowrap input-group-lg ms-2" v-if="showSearch">
                <input id="main-search-input" type="search" class="form-control" placeholder="Αναζήτηση..."
                  aria-label="search" aria-describedby="addon-wrapping">
                <div class="searchIcon">
                  <i class="fa fa-search"></i>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <!--end of Navigation bar-->

      <div id="main-container">
        <LoadingSpinner :isLoading="isLoading" />
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { fetchUserInfo, getAllUnreadNotifications } from '../services/user';
  import LoadingSpinner from '../components/LoadingSpinner.vue';
  import $ from 'jquery';

  // Refs
  const pageHeader = ref(null);
  const isLoading = ref(false);
  const userInfo = ref(null);
  const users = ref([]);
  const showUsersContainer = ref(true);
  const menuItemsCollapsed = ref(['dashboard', 'contacts']);
  const isMenuOpen = ref(false);
  const isNotificationsOpen = ref(false);
  const isSidebarOpen = ref(false);
  const isSidebarMini = ref(false);
  const showSearch = ref(true);
  const notificationCount = ref(0);

  const router = useRouter();
  const route = useRoute();

  let notificationInterval;

  // Update header and search visibility based on route
  const updateHeaderAndSearch = () => {
    const newPath = route.fullPath;

    showSearch.value = !(
      newPath.includes('/change-password') ||
      newPath.includes('/statistics') ||
      newPath.includes('/notifications-municipality') ||
      newPath.includes('/users') ||
       newPath.includes('/venues') ||
      newPath.includes('/event-categories') ||
      newPath.includes('/notifications')
    );

    if (newPath.includes('/statistics')) pageHeader.value = 'Στατιστικά';
    else if (newPath.includes('/notifications-municipality')) pageHeader.value = 'Ειδοποιήσεις';
    else if (newPath.includes('/events')) pageHeader.value = 'Εκδηλώσεις';
    else if (newPath.includes('/event-categories')) pageHeader.value = 'Κατηγορίες';
    else if (newPath.includes('/users')) pageHeader.value = 'Χρήστες';
    else if (newPath.includes('/venue')) pageHeader.value = 'Χώροι Εκδηλώσεων';
  };

  // Watch route changes
  watch(() => route.fullPath, updateHeaderAndSearch);

  // Toggle sidebar open/close
  const toggleSidebar = () => {
    isSidebarOpen.value = !isSidebarOpen.value;
    if (isSidebarOpen.value) {
      $('.sidebar').addClass('open');
      if (isSidebarMini.value) $('.sidebar').addClass('sidebar-mini');
    } else {
      $('.sidebar').removeClass('open sidebar-mini');
    }
  };

  // Menu toggle
  const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
    isNotificationsOpen.value = false;
  };

  // Notification toggle
  const getMentionTypeLink = (notification) => {
    let ret = notification.description;
    if (notification.username) ret += ` from: <span class="username">${notification.username}</span>`;
    return ret;
  };

  const toggleNotificationMenu = async () => {
    isNotificationsOpen.value = !isNotificationsOpen.value;
    isMenuOpen.value = false;

    if (isNotificationsOpen.value) {
      try {
        const response = await getAllUnreadNotifications();
        if (response?.data) {
          const notifications = response.data.data;
          if (Array.isArray(notifications)) {
            const notificationsList = document.getElementById('notifications-list');
            notificationsList.innerHTML = '';
            $("#notificationsCount").text(notifications.length);

            notifications.forEach(notification => {
              const listItem = document.createElement('li');
              listItem.className = 'py-2 mb-1 border-bottom';

              const notificationMessage = document.createElement('p');
              notificationMessage.className = 'notification-message';
              notificationMessage.innerHTML = getMentionTypeLink(notification);
              listItem.appendChild(notificationMessage);

              const timestamp = document.createElement('span');
              timestamp.textContent = notification.created_at;
              listItem.appendChild(timestamp);

              notificationsList.appendChild(listItem);
            });
          } else {
            console.error("Notifications data is not in the expected format:", notifications);
          }
        } else {
          console.error("Response data is missing:", response);
        }
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    }
  };

  // Open/collapse main menu item
  const openMainMenuItem = (menuItem) => {
    const index = menuItemsCollapsed.value.indexOf(menuItem);
    if (index > -1) menuItemsCollapsed.value.splice(index, 1);
    else menuItemsCollapsed.value.push(menuItem);
  };

  // Computed styles
  const menuStyle = computed(() => ({
    top: isMenuOpen.value ? '100%' : 'initial',
    right: isMenuOpen.value ? '0' : 'initial'
  }));

  const notificationStyle = computed(() => ({
    top: isNotificationsOpen.value ? '100%' : 'initial',
    right: isNotificationsOpen.value ? '0' : 'initial'
  }));

  // Fetch user data
  const fetchUserData = async () => {
    try {
      const response = await fetchUserInfo();
      userInfo.value = response.data?.info || null;

      if (userInfo.value?.customer_id === null && userInfo.value?.superUser === 1) {
        showUsersContainer.value = true;
        fetchUsersData();
      } else {
        showUsersContainer.value = false;
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
    }
  };

  // Fetch users data
  const fetchUsersData = async () => {
    try {
      showUsersContainer.value = response.data.success;
      if (response.data.success) users.value = response.data.data;
      else console.error("Failed to fetch users:", response.data.message);
    } catch (error) {
      showUsersContainer.value = false;
      console.error("Failed to fetch users:", error);
    }
  };

  // Fetch notifications count
  const fetchNotificationCount = async () => {
    try {
      const response = await getAllUnreadNotifications();
      notificationCount.value = response.data?.data?.length || 0;
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  // Check if route is active
  const isActive = (path) => route.path === path;

  // Close menus on outside click
  const closeMenu = (event) => {
    if (!document.querySelector('.user-menu')?.contains(event.target) &&
        !document.querySelector('.user-menu-toggler')?.contains(event.target)) {
      isMenuOpen.value = false;
    }
    if (!document.querySelector('.notifications-menu')?.contains(event.target) &&
        !document.querySelector('.notifications-menu-toggler')?.contains(event.target)) {
      isNotificationsOpen.value = false;
    }
  };

  // Logout
  const logout = (event) => {
    event.preventDefault();
    localStorage.removeItem('api_token');
    localStorage.removeItem('main_auth_token');
    router.push('/');
  };

  // Loading helpers
  const startLoading = () => isLoading.value = true;
  const stopLoading = () => isLoading.value = false;

  // Lifecycle hooks
  onMounted(() => {
    updateHeaderAndSearch();

    if (!userInfo.value) fetchUserData();

    document.addEventListener('click', closeMenu);

    const currentTheme = localStorage.getItem('theme');
    if (currentTheme) document.documentElement.setAttribute('data-theme', currentTheme);

    router.beforeEach((to, from, next) => {
      startLoading();
      next();
    });

    router.afterEach(() => stopLoading());

    fetchNotificationCount();
    notificationInterval = setInterval(fetchNotificationCount, 20000);
  });

  onUnmounted(() => {
    document.removeEventListener('click', closeMenu);
    clearInterval(notificationInterval);
  });
</script>



<style scoped>
  body{
    background-color: red !important;
  }
  .submenu.collapsed {
    display: none;
  } 

  .submenu.collapse {
    display: block;
  }

  .arrow.icofont-dotted-up {
    transform: rotate(180deg);
  }

  .active {
    color: #e9d2a4 !important;
    font-weight: bold; 
  }


  .m-link:hover{
    color: #e9d2a4 !important;
  }

  .icofont-close{
    display: none;
  }

 
  .navbar-toggler{
    position:absolute;
    top:95px;
  }

  .sidebar .sidebar-mini-btn{
    display: none;
  }


  @media (max-width: 1280px) {
    .sidebar .sidebar-mini-btn{
      display: block;
    }
  }

  @media (max-width: 575px) {
    .navbar-toggler{
      position:relative;
      top:0;  
    }
  }


</style>